// The invoice-scanning id account-signup-svc sent a signup's documents under,
// once it covers every current document (all pages share one id). Null while the
// send is still pending, or while it is being rebuilt under a new id after a
// document was added or removed.
export const scanIdForCurrentDocuments = signup => {
  const uploads = (signup && signup.invoiceScanningUploads) || {};
  const documentIds = (signup && signup.documentIds) || [];
  if (documentIds.length === 0) return null;
  const ids = documentIds.map(docId => uploads[docId]);
  return ids.every(id => !!id && id === ids[0]) ? ids[0] : null;
};
